import React from "react";
import BlurText from "../../Reactbits/TextAnimations/BlurText/BlurText";

function Hero() {
  return (
    <div
      style={{
        backgroundImage: "url('media/images/heroBackground.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        minHeight: "95vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div className="container text-white py-5">
        <div className="row">
          <div className="col-12 col-md-10 col-lg-8">
            <p className="mb-2 fs-5">1000+ premium jobs listed</p>
            <BlurText
              text="One Specialist Partner"
              className="display-4 fw-bold"
              animateBy="chars"
              direction="top"
              delay={50}
            />
            <p className="fs-3">
              90% of your Specialist IT implementation Delivered
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
